module.exports = {
    data() {
        return {
            modalVisible: false,
            body: document.body
        }
    },
    watch: {
    },
    methods: {
        showModal() {
          this.modalVisible = true;
          this.toggleBodyClass();
        },
        hideModal() {
            this.modalVisible = false;
            this.toggleBodyClass();

            let body = document.body;
            body.classList.remove('has-overlay');
        },
        toggleBodyClass() {
            let body = document.body;
            body.classList.toggle('has-overlay');
        },
    }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/modal.js